export type InventoryUnitOption = {
  value: string;
  label: string;
  allowFraction: boolean;
};

export const INVENTORY_UNIT_OPTIONS: InventoryUnitOption[] = [
  { value: "un", label: "Unidade (un)", allowFraction: false },
  { value: "pct", label: "Pacote (pct)", allowFraction: false },
  { value: "par", label: "Par", allowFraction: false },
  { value: "cx", label: "Caixa (cx)", allowFraction: false },
  { value: "fr", label: "Frasco (fr)", allowFraction: false },
  { value: "ml", label: "Mililitro (ml)", allowFraction: true },
  { value: "l", label: "Litro (L)", allowFraction: true },
  { value: "g", label: "Grama (g)", allowFraction: true },
  { value: "kg", label: "Quilograma (kg)", allowFraction: true },
];

export function unitAllowsFraction(unitLabel: string): boolean {
  return (
    INVENTORY_UNIT_OPTIONS.find((option) => option.value === unitLabel)?.allowFraction ??
    false
  );
}

export function maskQuantityInput(value: string, allowFraction: boolean): string {
  const normalized = String(value || "")
    .replace(".", ",")
    .replace(/[^\d,]/g, "");

  if (!normalized) return "";

  if (!allowFraction) {
    return normalized.split(",")[0] || "";
  }

  const [integerPart, ...fractionParts] = normalized.split(",");
  const mergedFraction = fractionParts.join("").slice(0, 3);
  if (fractionParts.length === 0) return integerPart;
  return `${integerPart || "0"},${mergedFraction}`;
}

export function quantityInputToNumber(value: string): number {
  const normalized = String(value || "")
    .replace(",", ".")
    .trim();
  if (!normalized) return 0;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatQuantityForUnit(quantity: number, unitLabel: string): string {
  const normalizedQuantity = Number.isFinite(Number(quantity)) ? Number(quantity) : 0;
  const formattedQuantity = normalizedQuantity.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: unitAllowsFraction(unitLabel) ? 3 : 0,
  });

  return `${formattedQuantity} ${unitLabel || "un"}`;
}
